function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useMemo } from "react";
import { useBreakpoints } from "../../Breakpoints/BreakpointsProvider";
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var _base;
var buildStyle = function(param, param1) {
    var backgroundColor = param.backgroundColor, borderColor = param.borderColor, font = param.font, size = param.size, spacing = param.spacing, experimentalBlocks = param.experimentalBlocks, readingDirection = param1.readingDirection;
    return {
        section: {
            base: _objectSpread({
                display: 'block',
                width: '100%',
                padding: 0,
                outlineWidth: 1,
                border: 0,
                backgroundColor: (_base = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.backgroundColor.interactive.base) !== null && _base !== void 0 ? _base : backgroundColor.interactive.base,
                borderTop: "1px solid ".concat(borderColor.soft),
                fontFamily: font.base.family,
                fontSize: font.base.size.s,
                color: font.color.base,
                '&:last-of-type': {
                    borderBottom: "1px solid ".concat(borderColor.soft)
                }
            }, readingDirection),
            container: {
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: backgroundColor.interactive.hover
                },
                '&:focus-visible': {
                    outline: 0,
                    boxShadow: "inset 0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.interactive.focus)
                }
            }
        },
        header: {
            base: {
                padding: spacing[3]
            },
            paddingMode: {
                normal: {
                    padding: spacing[3]
                },
                roomy: {
                    paddingTop: spacing[5],
                    paddingRight: spacing[3],
                    paddingBottom: spacing[5],
                    paddingLeft: spacing[3]
                }
            },
            small: {
                paddingRight: 0,
                paddingLeft: 0
            }
        },
        labelText: {
            base: {
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        },
        descriptionText: {
            base: {
                color: font.color.soft,
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                textOverflow: 'ellipsis'
            }
        },
        panel: {
            base: _objectSpread({}, readingDirection),
            text: {
                paddingBottom: spacing[3]
            }
        }
    };
};
var switchPaddingMode = function(param) {
    var modeName = param.modeName, paddingStyle = param.paddingStyle;
    return modeName === 'normal' ? paddingStyle === null || paddingStyle === void 0 ? void 0 : paddingStyle.normal : paddingStyle === null || paddingStyle === void 0 ? void 0 : paddingStyle.roomy;
};
export var useStyle = function(param) {
    var isRtl = param.isRtl, isOpen = param.isOpen, paddingMode = param.paddingMode;
    var isS = useBreakpoints().isS;
    var ref2;
    var ref1 = (ref2 = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref2 !== void 0 ? ref2 : {}, section = ref1.section, header = ref1.header, labelText = ref1.labelText, descriptionText = ref1.descriptionText, panel = ref1.panel;
    return useMemo(function() {
        var descriptionTextStyle = function() {
            var nonIEStyle = _objectSpread({}, isOpen ? {} : {
                WebkitLineClamp: 2,
                overflow: 'hidden'
            });
            if (typeof window !== 'undefined') {
                var ref;
                var isIE = !!(window === null || window === void 0 ? void 0 : (ref = window.document) === null || ref === void 0 ? void 0 : ref.documentMode);
                if (isIE) {
                    return _objectSpread({}, isOpen ? {} : {
                        whiteSpace: 'nowrap',
                        wordWrap: 'break-word',
                        overflow: 'hidden'
                    });
                }
                return _objectSpread({}, nonIEStyle);
            }
            return _objectSpread({}, nonIEStyle);
        };
        return {
            section: _objectSpread({}, section === null || section === void 0 ? void 0 : section.base),
            container: _objectSpread({}, section === null || section === void 0 ? void 0 : section.container),
            header: _objectSpread({}, switchPaddingMode({
                modeName: paddingMode,
                paddingStyle: header === null || header === void 0 ? void 0 : header.paddingMode
            }), isS && (header === null || header === void 0 ? void 0 : header.small)),
            labelText: _objectSpread({}, labelText === null || labelText === void 0 ? void 0 : labelText.base, isOpen ? {} : {
                whiteSpace: 'nowrap'
            }),
            descriptionText: _objectSpread({}, descriptionText === null || descriptionText === void 0 ? void 0 : descriptionText.base, descriptionTextStyle()),
            panel: _objectSpread({}, panel === null || panel === void 0 ? void 0 : panel.base),
            panelText: _objectSpread({}, panel === null || panel === void 0 ? void 0 : panel.text)
        };
    }, [
        descriptionText === null || descriptionText === void 0 ? void 0 : descriptionText.base,
        header === null || header === void 0 ? void 0 : header.paddingMode,
        header === null || header === void 0 ? void 0 : header.small,
        isOpen,
        isS,
        labelText === null || labelText === void 0 ? void 0 : labelText.base,
        paddingMode,
        panel === null || panel === void 0 ? void 0 : panel.base,
        panel === null || panel === void 0 ? void 0 : panel.text,
        section === null || section === void 0 ? void 0 : section.base,
        section === null || section === void 0 ? void 0 : section.container
    ]);
};
